var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workFlowContainer"},[_c('van-nav-bar',{attrs:{"title":"审批流","left-text":"","left-arrow":"","fixed":true},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"workFlowIndexBox"},[_c('mainInfo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }